// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__2b4HZ","content":"style_content__2dcPs","loader":"style_loader__3kP51","success":"style_success__yIMXC","not-found":"style_not-found__EpCQE"};